import React, { useEffect, useState } from 'react';
import { getRequest } from '../../utils/httpRequest';
import PropTypes from 'prop-types';
import { t } from "../../utils/i18n";

const ProfileOffers = ({ userId, currentExternalProfileId }) => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTab, setSelectedTab] = useState('sell');

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await getRequest(`/p2p_trades/offers/by-user/${userId}`);
        setOffers(response.body.data.items);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchOffers();
  }, [userId]);

  if (loading) return <p>{t("trades.profile_offers.loading")}</p>;
  if (error) return <p>{t("trades.profile_offers.error", { message: error.message })}</p>;

  const filteredOffers = offers.filter(offer => offer.offerTypeField.toLowerCase() === selectedTab);

  const isCurrentUserOffer = filteredOffers.some(offer => offer.profile.id === currentExternalProfileId);

  return (
    <div>
      <h4 className="text-info">{t("trades.profile_offers.offers")}</h4>
      <hr />
      {isCurrentUserOffer ? (
        <a href="/p2p_trades/offers/my_offers" className="btn btn-primary">{t("trades.profile_offers.view_my_offers")}</a>
      ) : (
        <>
          <div className="nav nav-tabs">
            <button onClick={() => setSelectedTab('sell')} className={selectedTab === 'sell' ? 'active-purple' : ''}>{t("trades.profile_offers.buy")}</button>
            <button onClick={() => setSelectedTab('buy')} className={selectedTab === 'buy' ? 'active-orange' : ''}>{t("trades.profile_offers.sell")}</button>
          </div>
          {filteredOffers.length > 0 ? (
            <table className="table table-responsive w-100 d-block d-md-table">
              <thead>
                <tr>
                  <th>{t("trades.profile_offers.th_label")}</th>
                  <th>{t("trades.profile_offers.th_price")}</th>
                  <th>{t("trades.profile_offers.th_limit")}</th>
                  <th>{t("trades.profile_offers.th_method")}</th>
                  <th>{t("trades.profile_offers.th_trade")}</th>
                </tr>
              </thead>
              <tbody>
                {filteredOffers.map((offer) => (
                  <tr key={offer.id}>
                    <td>{offer.customOfferLabel}</td>
                    <td>{offer.tradeRate}</td>
                    <td>{offer.rangeMin}{offer.fiatCurrency.code} - {offer.rangeMax}{offer.fiatCurrency.code}</td>
                    <td>{offer.paymentMethodLabel}</td>
                    <td className='text-white'>
                      <a href={`/p2p_trades/offers/trade/${offer.id}/create`} className={selectedTab === 'buy' ? 'btn sell-btn' : 'btn buy-btn'}>
                        {selectedTab === 'buy' ? t("trades.profile_offers.sell_usd") : t("trades.profile_offers.buy_usd")}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>{selectedTab === 'buy' ? t("trades.profile_offers.no_buy") : t("trades.profile_offers.no_sell")}</p>
          )}
        </>
      )}
    </div>
  );
};

ProfileOffers.propTypes = {
  userId: PropTypes.string.isRequired,
  currentExternalProfileId: PropTypes.string.isRequired,
};

export default ProfileOffers;
